import React, { useEffect, useState } from 'react';
import { GetViewType } from "../../../utils/view-type";
import { useTranslation } from "react-i18next";
import Sort from "../../sort/sort";
import Search from "../../search/search";
import { Close, DeleteIcon, EditIcon, MailIcon, RedCloseIcon, RoleIcon, UploadListIcon, UsersIcon } from "../../../icons/icons";
import Filter from "../../filter/filter";
import DropDown from "../../../assets/dropDown/dropDown";
import Pagination from "../../pagination/pagination";
import CustomCheckBox from "../../UI/customCheckBox/customCheckBox";
import { Link, useNavigate } from "react-router-dom";
import { Delete, Get } from "../../../apis/api";
import { toast } from "react-toastify";
import LoadingFix from "../../loading-fix/loading-fix";
import DeleteModal from "../../deleteModal/deleteModal";
import { useSelector } from "react-redux";
import { UploadedDocs } from './components/UploadedDocs'

const CrewTable = ({ defaultValue, editItem, onChange, order }) => {
  const viewType = GetViewType()
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [nationality, setNationality] = useState([])
  const [deleteItem, setDeleteItem] = useState(null)
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [uploadedItemModal, setUploadedItemModal] = useState(null)
  const [uploadedItemData, setUploadedItemData] = useState({})
  const [perPage, setPerPage] = useState(10)
  const [searchTime, setSearchTime] = useState("")
  const [agentData, setAgentData] = useState([])

  const navigate = useNavigate()

  const lng = useSelector((state) => (state).common.lng)


  const user = useSelector((state) => state.user.user)



  const isAdmin = user?.role_key === "super_admin"


  useEffect(() => {
    handleList()
  }, [])

  useEffect(() => {
    if (uploadedItemModal)
      handleListUploaded()
  }, [uploadedItemModal])

  const handleListUploaded = () => {
    setLoading(true)
    Get(`${user?.role_key === "super_admin" ? "admin" : "agent/profile"}/crews/${uploadedItemModal}`).then((res) => {
      setUploadedItemData(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    handleAgentList()
  }, [])


  const handleAgentList = () => {
    setLoading(true)
    Get(`admin/crews/agents`).then((res) => {
      setAgentData(res)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    // setData(defaultValue)
  }, [defaultValue])

  const handleList = (page, per_page, search = "") => {
    setLoading(true)
    Get(`${user?.role_key === "super_admin" ? "admin" : "agent/profile"}/crews?page=${page || 1}&per_page=${per_page || 10}&q=${search}`).then((res) => {
      if (isAdmin)
        setData(res?.details?.data)
      else {
        setData(res?.data)
        setNationality(res?.nationality)
      }
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleEdit = (item) => {
    navigate(`/crew/single?mode=edit&id=${item.id}`)
  }


  const handleCloseDeleteModal = () => {
    setDeleteItem(null)
  }

  console.log({ isAdmin })
  const handleDeleteRequest = () => {
    // setLoadingDelete(true)
    // Delete(`basic-information/job/destroy/${deleteItem.id}` ).then((res) =>{
    //   setData(res?.details?.data)
    //   toast.success(res.msg)
    //   setDeleteItem(null)
    // }).finally(() => {
    //   setLoadingDelete(false)
    // })
  }
  const handleSort = (e) => {

    setData([])
    setTimeout(() => {
      setData(e)
    }, 0)
  }
  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1, perPage, e);

    }, 1000)
    setSearchTime(loop)

  }
  const handleStatus = (status) => {
    if (status === 1) {
      return (
        <div className={`rounded-lg text-center py-2 text-green-200 bg-green-100 text-[8px] md:text-xs w-full md:w-[86px]`}>
          فعال
        </div>
      )
    } else if (status === 2) {
      return (
        <div className={`rounded-lg text-center py-2 text-primary-400 bg-primary-400/10 text-[8px] md:text-xs w-full md:w-[86px]`}>
          غیرفعال
        </div>
      )
    } else if (status === 3) {
      return (
        <div className={`rounded-lg text-center py-2 text-red bg-red/10 text-[8px] md:text-xs w-full md:w-[86px]`}>
          قطع همکاری
        </div>
      )
    }
  }

  const handleDefault = (option) => {
    return defaultValue?.find((item) => {
      return option.id === item
    })
  }
  const handleAgent = (id) => {
    let find = agentData?.find((item => {
      return (
        item.id === id
      )
    }))
    if (find) {
      return find?.name + " " + find?.last_name
    }
  }

  console.log(data)
  return (
    <div className={`${!order && "my-container"}`}>
      {
        loading && <LoadingFix />
      }
      {
        deleteItem && <DeleteModal onClose={handleCloseDeleteModal} onDelete={handleDeleteRequest} loading={loadingDelete} />
      }
      {
        viewType === "WEB" ?
          <div
            className="relative overflow-x-auto w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300 overflow-hidden ">
            <table className="w-full text-sm text-gray-500">
              <thead className="text-xs text-gray-700 uppercase ">
                <tr className={"border-b border-gray-400"}>
                  <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                    <div className={"mt-1"}>
                      {t("row")}
                    </div>
                  </th>
                  <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex "}>
                      <Sort data={data} sortKey={"name"} onSort={(e) => handleSort(e)} />
                      {t("crewName")}
                    </div>
                  </th>

                  <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 justify-center flex"}>
                      <Sort data={data} sortKey={"nationality"} onSort={(e) => handleSort(e)} />
                      {t("nation")}
                    </div>
                  </th>
                  <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex flex justify-center"}>
                      <Sort data={data} sortKey={"en_name"} onSort={(e) => handleSort(e)} />
                      {t("jobs")}
                    </div>
                  </th>
                  <th scope="col" className=" py-3 mx-auto text-center font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex justify-center"}>
                      <Sort data={data} sortKey={"en_name"} onSort={(e) => handleSort(e)} />
                      {t("status")}
                    </div>
                  </th>
                  <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                    <div className={"mt-1 flex flex justify-center"}>
                      <Sort data={data} sortKey={"en_name"} onSort={(e) => handleSort(e)} />
                      {t("visaHistory")}
                    </div>
                  </th>
                  {
                    (user?.role_key === "super_admin") &&
                    <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                      <div className={"mt-1 flex flex justify-center"}>
                        <Sort data={data} sortKey={"en_name"} onSort={(e) => handleSort(e)} />
                        {t("agent")}
                      </div>
                    </th>
                  }

                  <th scope="col" className="px-6 py-3 text-left w-[200px] font-normal text-gray-600 text-sm">
                    <Search onChange={handleSearch} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((item, index) => (
                  <tr key={index} className="bg-white border-b border-gray-400">
                    <td className="px-6 py-4 text-center">
                      <div className={"text-gray-500 text-sm mt-1"}>
                        {index + 1}
                      </div>
                    </td>
                    <td className=" py-4 text-start text-primary-400 text-base font-medium w-1/5">
                      <div className={"mt-1"}>
                        <CustomCheckBox label={isAdmin ? item?.Crew_full_name : (item.name + " " + item.last_name)} defaultValue={handleDefault(item) === item.id} id={item.id} onCheck={() => onChange(item.id)} />
                      </div>
                    </td>

                    <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                      <div className={"mt-1 flex justify-center"}>
                        {isAdmin
                          ? item?.nationalityFA
                          : (lng == 'fa' ? nationality?.find(i => i.id == item.nationality)?.fa_name : nationality?.find(i => i.id == item.nationality)?.en_name)
                        }
                      </div>
                    </td>
                    <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                      <div className={"mt-1 flex justify-center"}>
                        {isAdmin ? item?.job_name : item.job?.name}
                      </div>
                    </td>
                    <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                      <div className={"mt-1 flex justify-center"}>
                        {handleStatus(item?.status) ?? '-'}
                      </div>
                    </td>
                    <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                      <Link to={"/crew/visa-history"} className={"mt-1 flex justify-center text-primary-300 cursor-pointer"}>
                        {t("visaHistory")}
                      </Link>
                    </td>
                    {
                      (user?.role_key === "super_admin") &&
                      <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                        <div className={"mt-1 flex justify-center"}>
                          {item?.Agent_full_name ?? '-'}
                          {/* {handleAgent(item.agent_id)} */}
                        </div>
                      </td>
                    }
                    <td className="px-6 py-4 text-right">
                      <div className={"flex justify-center cursor-pointer gap-2"}>
                        <button title={t('ConvertToUser')} onClick={() => alert('Coming Soon')}>
                          <RoleIcon className='w-6 h-6' />
                        </button>
                        {/* <UploadedDocs id={item?.id} /> */}
                        <Link to={`/crew/single?mode=edit&id=${item.id}&def=docs`} onClick={() => setUploadedItemModal(item?.id)}>
                          <UploadListIcon />
                        </Link>
                        <button onClick={() => handleEdit(item)}>
                          <EditIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter />
              <div className={"w-full"}>
                <Search onChange={handleSearch} />
              </div>
            </div>
            {
              data?.data?.map((item, index) => {
                return (
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"mx-1 min-w-7"}>{index + 1}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-full justify-between"}>
                          <div className={"flex w-1/2 flex-col"}>
                            <CustomCheckBox label={isAdmin ? item?.Crew_full_name : (item.name + " " + item.last_name)} defaultValue={handleDefault(item) === item.id} id={item.id} onCheck={() => onChange(item.id)} />

                          </div>
                          <div className={"flex w-1/2 justify-end text-end text-sm"}>
                            {isAdmin
                              ? item?.nationalityFA
                              : (lng == 'fa' ? nationality?.find(i => i.id == item.nationality)?.fa_name : nationality?.find(i => i.id == item.nationality)?.en_name)
                            }
                          </div>
                        </div>
                        <div className={"flex w-full justify-between items-center"}>
                          {
                            (user?.role_key === "super_admin") &&
                            <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                              <div className={"mt-1 flex justify-center"}>
                                {/* {handleAgent(item.agent_id)} */}
                                {item?.Agent_full_name ?? '-'}

                              </div>
                            </td>
                          }
                          <div className={"flex w-1/4 text-sm text-gray-900 text-center justify-end"}>
                            {handleStatus(item.status)}
                          </div>
                          <div className={"flex w-1/3 text-sm text-gray-900 justify-center text-center"}>{item.job?.name}</div>
                          <div className={"flex justify-between cursor-pointer"}>
                            <button onClick={() => handleEdit(item)}>
                              <EditIcon />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
      }
      <div onClick={(e) => e.target === e.currentTarget && setUploadedItemModal(null)} className={`${uploadedItemModal ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0 z-30  items-center justify-center z-40`}>
        <div className={"bg-white rounded-2xl p-5 w-[80%]"}>
          <div className={"flex items-center mb-8 justify-between"}>
            <span className={'text-primary-400 text-base'}>
              {/*{t("createPassword")}*/}
            </span>
            <span onClick={() => setUploadedItemModal(null)} className={"cursor-pointer"}>
              <Close color={"#8A9098"} />
            </span>
          </div>
          <div className={"grid grid-cols-1 md:grid-cols-4 gap-5"}>
            <img className={"max-w-full"} src={"https://api.flysepehr.com/storage" + uploadedItemData?.cdc_file} />
            <img className={"max-w-full"} src={"https://api.flysepehr.com/storage" + uploadedItemData?.passport_file} />
            <img className={"max-w-full"} src={"https://api.flysepehr.com/storage" + uploadedItemData?.picture} />
            <img className={"max-w-full"} src={"https://api.flysepehr.com/storage" + uploadedItemData?.reg_file} />

          </div>

        </div>
      </div>
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown onChange={(per_page) => {
          handleList(1, per_page)
          setPerPage(per_page)
        }} />
        <Pagination itemsPerPage={data?.per_page} total={data?.total} last_page={data?.last_page} changePage={(page) => handleList(page, perPage)} />
      </div>
    </div>
  );
};

export default CrewTable;
